import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { EmailsIcon, ViewIcon, tableEditIcon } from "../../../assets/images";
import { ClientDirectoryListType } from "../../../redux/clientDirectory/clientDirectoryType";
import {
  formatDate,
  formateDateWithTime,
} from "../../../utils/commonFunctions";
import {
  COLOR_CODES,
  FONT_COL_CODES,
  STAGE_COLOR_CODES,
} from "../../../constant/colors";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { SendEmailPayload } from "../../../commonTypes/clientDirectoryTypes";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
type AppProps = {
  clientDirectoryList: [] | ClientDirectoryListType[];
  isEditClientPresent?: boolean;
  tableHeader: [] | TableHeadersType[];
  handleEditClientDirectory: (clientCode: string) => void;
  handleViewClientDirectory: (clientCode: string) => void;
  handleConfirmationModal: () => void;
  handleChangeClientStatusChangeData: (data: any) => void;
  isViewClientPresent: boolean;
  handleToggleSentEmailToClient: () => void;
  handleSentEmailToClient: (data: SendEmailPayload) => void;
  handleSendEmail: (data: SendEmailPayload) => void;
  isEmailClientPresent: boolean;
};
const ClientDirectoryTableData = ({
  clientDirectoryList,
  tableHeader,
  isEditClientPresent,
  handleEditClientDirectory,
  handleViewClientDirectory,
  handleConfirmationModal,
  handleChangeClientStatusChangeData,
  isViewClientPresent,
  handleToggleSentEmailToClient,
  handleSentEmailToClient,
  handleSendEmail,
  isEmailClientPresent,
}: AppProps) => {
  const backColor = (name: any) => {
    switch (name[0].toLowerCase()) {
      case "a":
      case "k":
      case "u":
        return COLOR_CODES[0];
      case "b":
      case "l":
      case "v":
        return COLOR_CODES[1];
      case "c":
      case "m":
      case "w":
        return COLOR_CODES[2];
      case "d":
      case "n":
      case "x":
        return COLOR_CODES[3];
      case "e":
      case "o":
      case "y":
        return COLOR_CODES[4];
      case "f":
      case "p":
      case "z":
        return COLOR_CODES[5];
      case "g":
      case "q":
      case "j":
        return COLOR_CODES[6];
      case "h":
      case "r":
      case "t":
        return COLOR_CODES[7];
      case "i":
      case "s":
        return COLOR_CODES[8];
      default:
        return COLOR_CODES[9];
    }
  };
  const styleColor = (name: string) => {
    return {
      padding: "4px 12px",
      color: "white",
      background: `${backColor(name)}`,
      borderRadius: "16px",
    };
  };
  const blank = () => {
    return {
      // color:"white"
    };
  };

  const getClientBadgeBackground = (type: string) => {
    let backgroundColor;
    let fontColor;

    if (type === "Finac") {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (type === "AU Bank") {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    } else {
      backgroundColor = STAGE_COLOR_CODES[3];
      fontColor = FONT_COL_CODES[3];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };

  const getSignUpBadgeStyle = (type: string) => {
    const { backgroundColor, fontColor } = getClientBadgeBackground(type);

    return {
      display: "inline-block",
      padding: "4px 10px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
      whiteSpace: "nowrap",
      fontSize: "12px",
      maxWidth: "100%",
      width: "fit-content",
      marginTop: "10px",
    };
  };

  const getChannelPartnerLabel = (
    partner: string | null | undefined
  ): string => {
    const value = partner?.trim().toLowerCase();

    switch (value) {
      case "finac":
        return "Finac";
      case "au_bank":
        return "AU Bank";
      default:
        return "Created By Admin";
    }
  };

  const handleEnableDisableClick = (data: any) => {
    handleConfirmationModal();
    handleChangeClientStatusChangeData(data);
  };
  return (
    <>
      {clientDirectoryList &&
        clientDirectoryList?.length > 0 &&
        clientDirectoryList?.map((data: any) => {
          return (
            <tr>
              {tableHeader &&
                tableHeader?.length > 0 &&
                tableHeader?.map((item: any) => {
                  if (item.value === "company_name") {
                    return (
                      <td className="text-start" style={{ width: "180px" }}>
                        <span>
                          {data?.company_name
                            ? `${data?.company_name} (${data?.client_code})`
                            : "--/--"}
                        </span>
                      </td>
                    );
                  } else if (item.value === "contact_type") {
                    return (
                      <td className="text-start" style={{ width: "180px" }}>
                        <span
                          style={
                            data?.contact_type
                              ? styleColor(data?.contact_type)
                              : blank()
                          }
                        >
                          {data?.contact_type ? data?.contact_type : "--/--"}
                        </span>
                      </td>
                    );
                  } else if (item.value === "branch_name") {
                    return (
                      <td className="text-start">
                        {!data?.branch_name ? "--/--" : data?.branch_name}
                      </td>
                    );
                  } else if (item.value === "client_category") {
                    const clientCategoryArray = JSON.parse(
                      data?.client_category || "[]"
                    );

                    return (
                      <td className="text-start" style={{ minWidth: "200px" }}>
                        {clientCategoryArray.length > 0
                          ? clientCategoryArray.map(
                              (category: string, index: number) => (
                                <div
                                  className="d-flex justify-content-sm-start"
                                  key={index}
                                >
                                  <span
                                    style={{
                                      marginLeft: "10px",
                                      marginTop: "2px",
                                    }}
                                  >
                                    {category}
                                  </span>
                                </div>
                              )
                            )
                          : "--/--"}
                      </td>
                    );
                  } else if (item.value === "scope_of_work") {
                    const scopeOfWorkArray = JSON.parse(
                      data?.scope_of_work || "[]"
                    );

                    return (
                      <td className="text-start" style={{ minWidth: "200px" }}>
                        {scopeOfWorkArray?.length > 0
                          ? scopeOfWorkArray?.map(
                              (scope: any, index: number) => (
                                <div
                                  className="d-flex justify-content-sm-start"
                                  key={index}
                                >
                                  <span
                                    style={{
                                      marginLeft: "10px",
                                      marginTop: "2px",
                                    }}
                                  >
                                    {scope}
                                  </span>
                                </div>
                              )
                            )
                          : "--/--"}
                      </td>
                    );
                  } else if (item.value === "client_from") {
                    const label = getChannelPartnerLabel(data?.channel_partner);
                    return (
                      <td style={{ minWidth: "150px" }}>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>
                            {data?.client_from
                              ? formatDate(data?.client_from)
                              : "--/--"}
                          </span>
                          <span style={getSignUpBadgeStyle(label)}>
                            {label}
                          </span>
                        </div>
                      </td>
                    );
                  } else if (item.value === "status") {
                    return (
                      <td style={{ maxWidth: "80px" }}>
                        {data?.is_active === 0 ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "left",
                              alignItems: "center",
                              gap: "3px",
                            }}
                          >
                            <label className="switchs m-0">
                              <input
                                type="checkbox"
                                checked={data?.is_active === 0 ? false : true}
                                onChange={() => handleEnableDisableClick(data)}
                              />
                              <span
                                className="sliders rounds"
                                style={{
                                  backgroundColor:
                                    data?.is_active === 0 ? "gray" : "",
                                }}
                              ></span>
                            </label>
                          </div>
                        ) : (
                          <div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                                gap: "3px",
                              }}
                            >
                              <label className="switchs m-0">
                                <input
                                  type="checkbox"
                                  checked={data?.is_active === 0 ? false : true}
                                  onChange={() =>
                                    handleEnableDisableClick(data)
                                  }
                                  disabled={
                                    data?.is_active === 0 ? true : false
                                  }
                                />

                                <span
                                  className="sliders rounds"
                                  style={{
                                    backgroundColor:
                                      data?.is_active === 0 ? "gray" : "",
                                  }}
                                ></span>
                              </label>
                            </div>
                          </div>
                        )}
                      </td>
                    );
                  } else if (item.value === "updated_at") {
                    return (
                      <td className="text-start" style={{ minWidth: "180px" }}>
                        <UpdatedByAndUpdatedAt
                          firstName={
                            JSON.parse(data?.updated_by)[0]?.first_name
                          }
                          lastName={JSON.parse(data?.updated_by)[0]?.last_name}
                          profilePic={
                            JSON.parse(
                              JSON.parse(data?.updated_by)[0]?.profile_pic
                            )?.file_url
                          }
                          updatedAt={formateDateWithTime(data?.updated_at)}
                        />
                        {/* {data?.updated_by}
                        <br />
                        <span className="due-date-text">
                          {formateDateWithTime(data?.updated_at)}
                        </span> */}
                      </td>
                    );
                  } else if (data[item.value]) {
                    return <td className="text-start"> {data[item.value]}</td>;
                  } else {
                    return <td className="text-start"> --/-- </td>;
                  }
                })}
              <td style={{ width: "50px", textAlign: "start" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  {isEditClientPresent && (
                    <span
                      className="d-inline-block pointer"
                      onClick={() =>
                        handleEditClientDirectory?.(data?.client_code)
                      }
                    >
                      <div
                        style={{
                          color: "#d43",
                          fontSize: 20,
                          // width: "50px",
                        }}
                      >
                        <img src={tableEditIcon} alt="" />
                      </div>
                    </span>
                  )}
                  {isViewClientPresent && (
                    <span
                      className="d-inline-block pointer"
                      onClick={() =>
                        handleViewClientDirectory?.(data?.client_code)
                      }
                    >
                      <div
                        style={{
                          color: "#d43",
                          fontSize: 20,
                          width: "50px",
                        }}
                      >
                        <img src={ViewIcon} alt="" />
                      </div>
                    </span>
                  )}
                  {isEmailClientPresent &&
                    data?.contact_type !== "Lead" &&
                    data?.contact_type !== "Lead & Supplier" && (
                      <div>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="send-email-tooltip">
                              Send Email
                            </Tooltip>
                          }
                        >
                          <span className="d-inline-block pointer ml-2">
                            <div
                              style={{
                                color: "#d43",
                                fontSize: 20,
                                width: "30px",
                              }}
                              onClick={() => {
                                handleToggleSentEmailToClient();
                                handleSentEmailToClient({
                                  to_email: data?.email,
                                  client_code: data?.client_code,
                                });
                              }}
                            >
                              <img src={EmailsIcon} alt="" />
                            </div>
                          </span>
                        </OverlayTrigger>
                      </div>
                    )}
                </div>
              </td>
            </tr>
          );
        })}
    </>
  );
};

export default ClientDirectoryTableData;
